import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) => ({
    Wrapper: {
        marginTop: "20px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
    },
    StatusesList: {
        zIndex: 10,
        // position: "absolute",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        height: "50px",
        maxWidth: "calc(100% - 80px)",
        overflowX: "auto",
        overflowY: "hidden",
        whiteSpace: "nowrap",
        scrollbarWidth: "thin",
        '&::-webkit-scrollbar': { height: 4 },
        '&::-webkit-scrollbar-thumb': { background: '#f0c99a', borderRadius: 4 },
        '& p': {
            fontSize: "15px",
        },
        '& span': {
            color: "orange",
            fontSize: "15px",
        }
    },
    ToMain: {
        fontSize: "20px",
        cursor: "pointer"
    },
    Head: {    
        display: "flex",
        justifyContent: "space-between",
    }
}));

